/* Raghu  26/10/2022   3075154998   Inputfields Alignments and Enhancements
akhila    10/28/2022 3075154998 enable framework UX changes
/* Rohini 10/29/2022 3075154998 add classname globally for the buttons */
/* Rohini 10/31/2022 3075154998 changed the properties for the classname root for accordian header */
import React, {useEffect, useState, useContext} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, Button, FormControl, FormHelperText, Typography} from '@material-ui/core';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {Controller} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import DialogBox from '../../../../../components/DialogBox';
import {FILE_FORMATS} from '../../../../../constants/Lookup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import MediaTypeSystemNotes from './MediaTypeSystemNotes';
import {makeStyles} from '@material-ui/core/styles';

import {
  postMediaType,
  resetStatus,
  fetchDropdownData,
  ResetAddRecord as resetAddRecord,
} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import {getObject} from '../../../../../util/GetDropdownObject';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import OverrideRule from '../../../../../components/OverrideRule';
import SearchDialog from './SearchDialog';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {

      backgroundColor: '#f3f3f3',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));

const options = [
  {value: 'Yes', valueCode: 'Y'},
  {value: 'No', valueCode: 'N'},
];

const typeOptions = [
  {value: 'Device', valueCode: 'D'},
  {value: 'Rule Group', valueCode: 'RG'},
];

const getObj = (val, options) => {
  const value = options.filter((i) => i.valueCode === val);
  return value[0];
};

const getDropObj = (typeCode, vals) => {
  let label = {};
  label = vals.filter((i) => i.value === typeCode);
  return label[0];
};

const AddMediaType = ({setTabValue, setCode, code, mediaName, setMediaName, isCopyData, setUsageState}) => {
  const [selectedType, setSelectedType] = useState('');
  const [searchShow, setSearchShow] = useState(false);
  const [dialogState, setDialogState] = useState(false);
  const [overRiding, setOverRiding] = useState({});
  const handleDialog = () => {
    setSearchShow(false);
  };

  const {
    addMediaTypeStatus,
    mediaTypeData,
    dropDownData,
    isLoading,
    successMsg,
    errorMsg,
    addMediaStatus,
    addRecordData,
    userMetrix,
  } = useSelector(({addMediaType}) => addMediaType);

  const [data, setData] = useState({});
  const [ruleCode, setRuleCode] = useState();
  const [resetting, setResetting] = useState(false);

  useEffect(() => {
    setData(mediaTypeData);
  }, [mediaTypeData, resetting]);

  const initialValues = {
    mediaType: isCopyData ? '' : data?.name || '',
    description: data?.description || '',
    fileType: data?.type ? getObject(data?.type, FILE_FORMATS, dropDownData) : '',
    deviceOrRuleGroup: data?.deviceOrRuleGroup ?
      getDropObj(data?.deviceOrRuleGroup, typeOptions) :
      '',
    device: data?.device ? data?.device : '',
    ruleGroup: data?.ruleGroup ? data?.ruleGroup : '',
    deviceType: data?.deviceType ? data?.deviceType : '',
    fixedLength: data?.fixedLength ? getObj(data?.fixedLength, options) : '',
    recordLength: data?.recordLength,
    ebcdicFormat: data?.format ? getObj(data?.format, options) : '',
    isMediaLabeled: data?.isLabeled ? getObj(data?.isLabeled, options) : '',
    noOfLabelRecords: data.noOfLabelRecord,
    labelRecordLength: data?.labelRecordLength,
    recordTerminator: data?.recordTerminator,
    initializeTape: data?.initializeTape ? getObj(data?.initializeTape, options) : '',
    override: 'No',
  };

  const [fixLength, setFixLength] = useState(true);
  const [expanded, setExpanded] = useState();

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const validationSchema = Yup.object().shape({
    mediaType: code && data?.name ? '' : Yup.string().required('Media type name is Required'),
    description: Yup.string().required('Description is Required'),
  });
  const dispatch = useDispatch();
  const classes1 = useStyles();
  const {handleSubmit, register, reset, errors, control} = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    reset(initialValues);
  }, [data, resetting, dropDownData]);

  useEffect(() => {
    if (!code) {
      setData({});
    }
  }, [code]);

  useEffect(() => {
    if (data?.deviceOrRuleGroup === 'Rule Group') {
      setSelectedType('Rule Group');
    } else if (data?.deviceOrRuleGroup === 'Device') {
      setSelectedType('Device');
    } else {
      setSelectedType('');
    }
  }, [data, resetting]);

  useEffect(() => {
    dispatch(fetchDropdownData());
  }, []);

  useEffect(() => {
    if (addMediaTypeStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRecord());
      }, 2500);
    }
  }, [userMetrix, addMediaTypeStatus]);
  useEffect(() => {
    if (addMediaStatus === 200) {
      setTimeout(() => {
        setTabValue(0);
        dispatch(resetStatus());
      }, 3000);
    }
  }, [addMediaStatus]);
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetStatus());
      }, 3000);
    }
  }, [errorMsg]);

  const {reusableInputStyles} = useContext(ThemeContext);

  const classes = reusableInputStyles();
  const handleDialogState = () => {
    setDialogState(false);
  };
  const onSubmit = (values) => {
    if (values) {
      const passValues = {
        id: isCopyData ? 0 : data?.id ? data?.id : 0,
        name: values?.mediaType ? values?.mediaType : data?.name ? data?.name : '',
        type: values?.fileType?.valueCode ? values?.fileType?.valueCode : '',
        description: values?.description ? values?.description : '',
        deviceOrRuleGroup: values?.deviceOrRuleGroup?.value ? values?.deviceOrRuleGroup?.value : '',
        device: values?.device ? values?.device : '',
        ruleGroup: ruleCode ?
          ruleCode :
          selectedType === 'Device' || selectedType === '' ?
            '' :
            data?.ruleGroup,
        deviceType: values?.deviceType ? values?.deviceType : '',
        fixedLength: values?.fixedLength?.valueCode ? values?.fixedLength?.valueCode : '',
        recordLength: values?.recordLength,
        format: values?.ebcdicFormat?.valueCode ? values?.ebcdicFormat?.valueCode : '',
        isMediaLabeled: values?.ebcdicFormat?.valueCode ? values?.ebcdicFormat?.valueCode : '',
        noOfLabelRecord: values?.noOfLabelRecords ? values?.noOfLabelRecords : '',
        labelRecordLength: values?.labelRecordLength,
        recordTerminator: values?.recordTerminator,
        initializeTape: values?.initializeTape?.valueCode ? values?.initializeTape?.valueCode : '',
        override: 'No',
      };
      dispatch(postMediaType(passValues));
      setOverRiding(passValues);
    }
  };

  return (
    <div className={`mb-0`}>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1`}
          onClick={() => {
            setTabValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
           Search Media Type
        </Button>
      </div>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="form-row global-field-textfields">
          <div className="col-sm-6 col-md-4 col-lg-3 form-group">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Media Type Name"
              margin="dense"
              disabled={data?.name && !isCopyData}
              name="mediaType"
              variant="outlined"
              label="Media Type Name"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
              required
              error={Boolean(errors.mediaType?.message)}
            />
            <FormHelperText>
              {errors.mediaType?.message ? errors.mediaType.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-6 col-md-8 col-lg-6 form-group ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Description"
              margin="dense"
              name="description"
              variant="outlined"
              label="Description"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
              required
              error={Boolean(errors.description?.message)}
            />
            <FormHelperText>
              {errors.description?.message ? errors.description.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    {...props}
                    id="fileType"
                    options={getOptions(FILE_FORMATS, dropDownData)}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option.valueCode === null}
                    getOptionLabel={(option) => {
                      return option && option.valueCode && option.value ?
                        option.valueCode + ' - ' + option.value :
                        option.value === null ?
                          option.valueCode :
                          '';
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        variant="outlined"
                        fullWidth
                        label="File Type"
                        name="fileType"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select File Type"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="fileType"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    {...props}
                    id="deviceOrRuleGroup"
                    options={typeOptions}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option.valueCode === null}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        variant="outlined"
                        fullWidth
                        label="Device/Rule Group"
                        name="deviceOrRuleGroup"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select Device/RuleGroup"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                      setSelectedType(data?.value ? data.value : '');
                      setRuleCode((selectedType === 'Device' || selectedType === '') && '');
                    }}
                  />
                )}
                name="deviceOrRuleGroup"
                control={control}
              />
            </FormControl>
          </div>
          {selectedType === 'Device' && (
            <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
              <TextField
                className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Enter Device"
                margin="dense"
                name="device"
                variant="outlined"
                label="Device"
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={register}
                fullWidth
              />
            </div>
          )}
          {selectedType === 'Rule Group' && (
            <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
              <TextField
                className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder="Search Rule Group"
                margin="dense"
                name="ruleGroup"
                variant="outlined"
                label="Rule Group"
                value={ruleCode}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      variant="contained"
                      onClick={() => setSearchShow(true)}
                      className={` ${classes.buttonRoot2}`}
                    >
                      Search
                    </Button>
                  ),
                }}
                inputRef={register}
                fullWidth
                error={Boolean(errors.ruleGroup?.message)}
              />
              <FormHelperText>
                {errors.ruleGroup?.message ? errors.ruleGroup.message : ''}
              </FormHelperText>
            </div>
          )}
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Device Type"
              margin="dense"
              name="deviceType"
              variant="outlined"
              label="Device Type"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    {...props}
                    id="fixedLength"
                    options={options}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option.valueCode === null}
                    renderOption={(option) => option.valueCode + ' - ' + option.value}
                    getOptionLabel={(option) => {
                      return option && option.valueCode;
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        variant="outlined"
                        fullWidth
                        label="Fixed Length"
                        name="fixedLength"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select Fixed Length"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                      setFixLength(data?.valueCode !== 'Y');
                    }}
                  />
                )}
                name="fixedLength"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Record Length"
              margin="dense"
              name="recordLength"
              disabled={data?.fixedLength === 'Y' ? false : fixLength}
              variant="outlined"
              label="Record Length"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    {...props}
                    id="ebcdicFormat"
                    options={options}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option.valueCode === null}
                    renderOption={(option) => option.valueCode + ' - ' + option.value}
                    getOptionLabel={(option) => {
                      return option && option.valueCode;
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        variant="outlined"
                        fullWidth
                        label="EBCDIC Format"
                        name="ebcdicFormat"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select EBCDIC Format"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="ebcdicFormat"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    {...props}
                    id="isMediaLabeled"
                    options={options}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option.valueCode === null}
                    renderOption={(option) => option.valueCode + ' - ' + option.value}
                    getOptionLabel={(option) => {
                      return option && option.valueCode;
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        variant="outlined"
                        fullWidth
                        label="is Media Labeled"
                        name="isMediaLabeled"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select Media Labeled"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="isMediaLabeled"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter No of Label Records"
              margin="dense"
              name="noOfLabelRecords"
              variant="outlined"
              label="No of Label Records"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Label Record Length"
              margin="dense"
              name="labelRecordLength"
              variant="outlined"
              label="Label Record Length"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <TextField
              className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder="Enter Record Terminator"
              margin="dense"
              name="recordTerminator"
              variant="outlined"
              label="Record Terminator"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group ">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    {...props}
                    id="initializeTape"
                    options={options}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option.valueCode === null}
                    renderOption={(option) => option.valueCode + ' - ' + option.value}
                    getOptionLabel={(option) => {
                      return option && option.valueCode;
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={` ${classes.labelName} ${classes.selectLabel}`}
                        variant="outlined"
                        fullWidth
                        label="Initialize Tape"
                        name="initializeTape"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select Initialize Tape"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="initializeTape"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 form-group d-flex align-items-center justify-content-end">
            <Button
              variant="outlined"
              className={`reset-btn mx-1 ${classes.buttonRoot}`}
              onClick={() => {
                if (!code) {
                  reset(initialValues);
                  setSelectedType('');
                  setRuleCode('');
                } else {
                  reset(initialValues);
                  setResetting(!resetting);
                }
              }}
            >
            Reset
            </Button>
            <Button
              variant="outlined"
              type="submit"
              className={`search-btn mx-1 ${classes.buttonRoot}`}
            >
            Save
            </Button>
          </div>
        </div>

      </form>
      <OverrideRule
        dialogTitle="Override Media Type"
        dialogOpen={dialogState}
        dialogClose={handleDialogState}
        title="This Media Type has been used in the following frameworks."
        data={addRecordData}
        handleOverrideClose={handleDialogState}
        handleOverrideSubmit={() => {
          dispatch(postMediaType({...overRiding, override: 'Yes'}));
          handleDialogState();
        }}
      />

      {code && (
        <div className={`${classes1.root} mt-3`}>
          <Accordion
            className="accordion-styling"
            expanded={expanded === 'panel1'}
            onChange={handleAccordionChange('panel1')}
          >
            <AccordionSummary
              expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography className={classes1.heading}>Media Type Notes</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes1.detailsCard}>
              <MediaTypeSystemNotes mediaName={mediaName} setMediaName={setMediaName} />
            </AccordionDetails>
          </Accordion>
        </div>
      )}
      <DialogBox open={searchShow} dialogClose={handleDialog} title="Rule Group" maxWidth="lg">
        <SearchDialog
          searchShow={searchShow}
          handleDialog={handleDialog}
          setRuleCode={setRuleCode}
        />
      </DialogBox>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default AddMediaType;
